import { ShipmentStatus } from "../types/ShipmentStatus";

export const shipmentStatusNameToIdMap = {
  [ShipmentStatus.NEW]: 1,
  [ShipmentStatus.DISPATCHED]: 2,
  [ShipmentStatus.COMPLETE]: 3,
  [ShipmentStatus.CANCELLED]: 4,
  [ShipmentStatus.ERROR]: 5,
};
